import GrouponLogoSVG from "@design-system/ui-icons/vanilla/GrouponLogo"
import { createIcon } from "../createIcon"

export const GrouponLogoIcon = createIcon(GrouponLogoSVG)
